const menuItems = document.querySelectorAll('.open-switcher');

menuItems.forEach(function (languages) {
	languages.addEventListener('click', function (e) {
		languages.nextElementSibling.classList.toggle('show');
		this.classList.toggle('show');
	})
});